import { getApiGalaxyServer } from 'services';

// prettier-ignore
export type MemberSearchSortBy =
  | 'teamId'
  | 'email'
  | 'firstName'
  | 'lastName'
  | 'tenant'
  | 'realmId'
  | 'lastBackfilled';

export type MemberSearchSortOrder = 'ASC' | 'DESC';

export type MemberStatus = 'active' | 'deactivated' | 'deleted';

export interface SearchMembersByFieldsPayload {
  tenant?: string;
  realmId?: string;
  teamId?: string;
  teamIds?: string[];
  teamIdsNot?: string[];
  text?: string;
  includeInactive?: boolean;
  teamStatus?: MemberStatus;
  isArchived?: boolean;
  page?: number;
  limit?: number;
  sortBy?: MemberSearchSortBy;
  sortOrder?: MemberSearchSortOrder;
}

export interface MemberSearchItem {
  id: string;
  tenant: string;
  realmId: string;
  teamId: string;
  email: string;
  firstName: string;
  lastName: string;
  lastBackfilled?: string | null;
  isArchived?: boolean;
  teamStatus?: MemberStatus;
}

export interface SearchMembersByFieldsResponse {
  data: MemberSearchItem[];
  total: number;
  page: number;
  limit: number;
}

export const searchMembersByFieldsApi = ({
  params,
  token,
  config,
}: BaseApiParams<SearchMembersByFieldsPayload>): Promise<any> =>
  getApiGalaxyServer(`/lookup/members/searchByFields`, { ...config, params: params as any }, token);
